(function () {
  document.querySelectorAll('[data-compare-table]').forEach(function (table) {
    var section = table.closest('.compare-custom');
    var prevBtn = section.querySelector('.compare-custom__arrow--prev');
    var nextBtn = section.querySelector('.compare-custom__arrow--next');
    var colWidth = 200 + 12;

    function updateArrows() {
      if (!prevBtn || !nextBtn) return;
      prevBtn.classList.toggle('compare-custom__arrow--inactive', table.scrollLeft <= 0);
      nextBtn.classList.toggle('compare-custom__arrow--inactive', table.scrollLeft + table.clientWidth >= table.scrollWidth - 1);
    }

    if (prevBtn) {
      prevBtn.addEventListener('click', function () {
        table.scrollBy({ left: -colWidth, behavior: 'smooth' });
      });
    }

    if (nextBtn) {
      nextBtn.addEventListener('click', function () {
        table.scrollBy({ left: colWidth, behavior: 'smooth' });
      });
    }

    table.addEventListener('scroll', updateArrows, { passive: true });
    updateArrows();
  });
})();
